import DirectReporteesTable from 'modules/planning/components/DirectReporteesTable'

const PeriodOverviewTab = () => {
  return <DirectReporteesTable />
}

export default PeriodOverviewTab
